import { useContext, useEffect, useRef, useState } from 'react';
import { LiaComments } from "react-icons/lia";
import { HiOutlineCurrencyRupee } from "react-icons/hi2"
import { GoBriefcase } from "react-icons/go";
import { LuFileUser } from "react-icons/lu";
import { LiaFileDownloadSolid } from "react-icons/lia";
import { DataProvider } from '../../store/ContextProvider';

function ListCandidate() {
  const { BeURL } = useContext(DataProvider);
  const searchRef = useRef();
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCandidates, setTotalCandidates] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [candidates, setCandidates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [comments, setComments] = useState([]);
  const [allcomments, setAllComments] = useState([]);
  const [viewingComment, setViewingComment] = useState(false);

  const fetchCandidates = async (filterOption) => {
    const filterOptions = filterOption || {}
    setLoading(true);
    try {
      const res = await fetch(`${BeURL}/list-candidates`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ page: currentPage, searchTerm, candidatesPerPage: itemsPerPage, filterOptions })
      });
      const data = await res.json();
      if (data.success) {
        setCandidates(data.candidates);
        setTotalCandidates(data.totalCandidates);
        // Recalculate pages based on selected itemsPerPage
        setTotalPages(data.totalPages);
      } else {
        setCandidates([]);
        setTotalCandidates(0);
        setTotalPages(0);
      }
    } catch (err) {
      console.error('Error fetching candidates:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetch(`${BeURL}/candidate/comments`, { credentials: "include" })
      .then(res => res.json())
      .then(data => {
        if (data.success) setAllComments(data.comments);
      });
  }, [])


  // Fetch candidates when page, searchTerm, or itemsPerPage changes
  useEffect(() => {

    if (currentPage <= totalPages) {
      fetchCandidates();
    }
    else {
      setCurrentPage(1)
    }


  }, [currentPage, itemsPerPage, BeURL]);

  useEffect(() => {
    if (searchTerm === "") {
      fetchCandidates()
    }
  }, [searchTerm])

  useEffect(() => {
    setCurrentPage(1)
  }, [itemsPerPage])

  const handlePagination = (dir) => {
    if (dir === 'prev' && currentPage > 1) {
      setCurrentPage(prev => prev - 1);
    }
    if (dir === 'next' && currentPage < totalPages) {
      setCurrentPage(prev => prev + 1);
    }
  };

  const handleSearch = () => {
    setCurrentPage(1);
    fetchCandidates()
  }

  const handleKeyDown = (e) => {

    if (e.key === "Enter") {
      handleSearch()
    }
  }

  const renderExp = (exp) => {
    if (exp) {
      if (exp.year && exp.month) {
        return `${exp.year}y ${exp.month}m`
      }
      else if (exp.year) {
        return `${exp.year}y`
      }
      else if (exp.month) {
        return `${exp.month}m`
      }
      else {
        return '-'
      }
    }
    else {
      return '-'
    }
  }

  const handleViewComment = (id) => {
    fetch(`${BeURL}/candidate/${id}/comments`, { credentials: "include" })
      .then(res => res.json())
      .then(data => {
        if (data.success) setComments(data.comments);
        setViewingComment(true);
      });


  }

  return (
    <div className="min-h-[80vh]">
      <h2 className="my-3 text-center font-semibold text-2xl">List Candidates</h2>

      {/* Search Box */}
      <div className="flex flex-wrap justify-center gap-2 items-center my-5">
        <div className="relative inline sm:w-[40vw]">
          <span className="material-symbols-outlined absolute left-0 top-1/2 transform -translate-y-1/2 translate-x-1/2 text-2xl">
            person_search
          </span>
          <input
            ref={searchRef}
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
            type="search"
            className="pl-10 pr-3 py-2 border rounded-lg w-full"
            placeholder="Search by role, skill, exp..."
            onKeyDown={e => handleKeyDown(e)}
          />
        </div>
        <button onClick={handleSearch} className="bg-primary-600 text-white p-2 px-3 rounded-lg cursor-pointer">
          Search
        </button>

        <button className='text-primary-500 bg-slate-200 p-2 px-3 rounded-lg cursor-pointer flex items-center justify-center gap-1' onClick={() => window.location.href = '/pro-search'}>
          <span className="material-symbols-outlined">
            manage_search
          </span>
          Pro Search
        </button>
      </div>


      {/* Candidates Table */}
      <div className="overflow-y-auto bg-white rounded-xl shadow-lg min-h-[55vh] max-h-[65vh] mx-auto">
        <div className="min-w-full divide-y divide-gray-200 relative">


          <div className=" relative">
            <div className="p-2 flex flex-col md:flex-row flex-wrap justify-center align-center gap-4 ">
              {!loading && (candidates.length ? (
                candidates.map((c, idx) => {
                  const comment = allcomments.find(comment => comment.candidateId === c._id)

                  return (
                    <div
                      key={c.applicantID}
                      className={`rounded-lg shadow-lg border-[0.5px] transition overflow-hidden hover:shadow-md hover:border-slate-300 w-96 ${idx % 2 === 0 ? "bg-gray-50" : "bg-white"
                        }`} >
                      <div className="relative  z-50 ">
                        <span className={`${c.newResumeStatus &&
                          "absolute bg-primary-300 -rotate-[45deg] -top-[6px] -left-[14px] h-5 w-8"
                          }`} ></span>
                      </div>

                      <div className='flex justify-start items-center align-center px-2 py-1'>
                        <div onClick={() => window.open(`/candidate/${c._id}`, "_blank")}>
                          <img className="h-[60px] rounded-full w-fit cursor-pointer"
                            title="View"
                            src={`https://ui-avatars.com/api/?name=${c.applicantName || c.applicantFullName}&background=e8eaff&color=2c25c4`}
                            alt="profile" />
                        </div>
                        <div>
                          <p
                            className="px-4 text-lg text-primary-400 hover:text-primary-200 font-semibold cursor-pointer"
                            title="View"
                            onClick={() => window.open(`/candidate/${c._id}`, "_blank")}>
                            {c.applicantName}
                          </p>

                          <p
                            className="px-4 pb-1 text-sm uppercase font-bold text-primary-400 hover:text-primary-200 cursor-pointer"
                            title="View"
                            onClick={() => window.open(`/candidate/${c._id}`, "_blank")} >
                            {c.candidateID}
                          </p>
                        </div>

                      </div>

                      {/* Experience + CTC */}
                      <div className="flex gap-8 items-center px-4 py-1 text-sm text-gray-700">
                        <p className="flex items-center gap-1 font-medium">
                          <GoBriefcase /> {renderExp(c.experience)}
                        </p>
                        <p className="flex items-center gap-1 font-medium">
                          <HiOutlineCurrencyRupee className='text-base' />{" "}
                          {c.currentCTC?.amount ? `${c.currentCTC.amount} LPA` : "-"}
                        </p>
                      </div>

                      {/* Job details */}
                      <p className="px-4 py-1 text-sm text-gray-400 font-medium">
                        Job Title:{" "}
                        <span className="text-gray-700 font-semibold">
                          {c.experiences?.[0]?.jobTitle || "-"}
                        </span>
                      </p>
                      <p className="px-4 py-1 text-sm text-gray-400 font-medium">
                        Created On:{" "}
                        <span className="text-gray-700">{c.createdOn ? (new Date(c.createdOn).toLocaleDateString("en-GB")) : (c.createdAt ? (new Date(c.createdAt).toLocaleDateString("en-GB")) : "-")}</span>
                      </p>

                      <p className="px-4 py-1 text-sm text-gray-400 font-medium pb-2">
                        Notice Period:{" "}
                        <span className="text-gray-700">{c.noticePeriod || "-"}</span>
                      </p>

                      {/* Action icons */}
                      <div className="px-4 py-2 border-t flex justify-between text-sm">
                        <div className="flex gap-3 items-center text-gray-600 ">
                          <div className='flex items-center gap-1 cursor-pointer text-primary-400 hover:text-primary-300' title='Profile View Counts' onClick={() => window.open(`/candidate/${c._id}`, "_blank")}>
                            <span className="material-symbols-outlined  text-xl">
                              visibility
                            </span><span>{c?.profileViewCount || 0}</span>
                          </div>
                          <div className='flex items-center gap-1' title='Resume View Counts'>
                            <LuFileUser className="text-base " />
                            <span>{c?.resumeViewCount || 0}</span>

                          </div>
                        </div>

                        <div className="flex gap-3 items-center text-gray-600 ">

                          <div className='flex items-center gap-1' title='Resume Download Counts'>
                            <LiaFileDownloadSolid className="text-lg " />
                            <span>{c?.resumeDownloadCount || 0}</span>
                          </div>

                          <div
                            title={comment ? "View Comments" : "No Comments available"}
                            className={`flex items-center gap-1 ${comment
                              ? " text-primary-300 hover:text-primary-100 cursor-pointer"
                              : " text-gray-400 cursor-not-allowed"
                              }`}
                            onClick={() => handleViewComment(c._id)}>
                            <LiaComments

                              className={`${comment
                                ? "text-lg "
                                : "text-lg "
                                }`}
                              onClick={() => handleViewComment(c._id)} />
                            <span>{comment?.comments.length || 0}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                })
              ) : (
                <div className="min-h-[50vh] flex justify-center items-center">
                  <span className="text-center p-4">No data available!</span>
                </div>
              ))}
            </div>
          </div>

          {
            loading &&
            <div>
              <div>
                <div className='min-h-[50vh] flex justify-center items-center'>
                  <div class="flex flex-row gap-2">
                    <div class="w-4 h-4 rounded-full bg-blue-700 animate-bounce [animation-delay:.7s]"></div>
                    <div class="w-4 h-4 rounded-full bg-blue-700 animate-bounce [animation-delay:.3s]"></div>
                    <div class="w-4 h-4 rounded-full bg-blue-700 animate-bounce [animation-delay:.7s]"></div>
                  </div>
                </div>
              </div>
            </div>
          }

        </div>



        {/* for popup */}
        {
          comments.length > 0 && viewingComment && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
              <div className="bg-white p-6 rounded-lg shadow-lg max-w-2xl w-full">
                <h3 className="text-xl font-semibold mb-4">Comments</h3>
                <div className="space-y-2 max-h-48 overflow-y-auto border p-2 rounded bg-gray-50">
                  {comments.length === 0 && <p className="text-sm text-gray-500">No comments yet</p>}
                  {comments.reverse().map((c, idx) => (
                    <div key={idx} className="p-2 border-b">
                      <p className="text-sm">{c.message}</p>
                      <p className="text-xs text-gray-500">
                        — {c.commentedByName} on {new Date(c.commentedOn).toLocaleString("en-GB")}
                      </p>
                    </div>
                  ))}
                </div>
                <button
                  onClick={() => setViewingComment(false)}
                  className="mt-4 bg-secondary-500 text-white px-4 py-2 rounded-lg hover:bg-secondary-400"
                >
                  Close
                </button>
              </div>
            </div>)
        }


      </div>

      {/* Pagination Controls */}
      <div className="mx-auto my-4 flex justify-between items-center">
        <div className="flex items-center gap-2">
          <label htmlFor="recordsPerPage" className="text-sm">Records per page:</label>
          <select
            id="recordsPerPage"
            value={itemsPerPage}
            onChange={e => setItemsPerPage(parseInt(e.target.value, 10))}
            className="ml-2 px-3 py-1 border rounded"
          >
            {[10, 20, 25, 50, 75, 100].map(n => (
              <option key={n} value={n}>{n}</option>
            ))}
          </select>
        </div>
        <div className="text-sm">Total Candidates: {totalCandidates}</div>
      </div>

      <div className="flex justify-center items-center gap-4">

        <span className={`p-2 text-primary-400 material-symbols-outlined text-4xl ${currentPage === 1 ? 'cursor-not-allowed' : 'cursor-pointer'}`}
          onClick={() => handlePagination('prev')}
          disabled={currentPage === 1}
        >
          chevron_left
        </span>

        <span>{currentPage} of {totalPages}</span>

        <span className={`p-2 text-primary-400 material-symbols-outlined text-4xl ${currentPage === totalPages ? 'cursor-not-allowed' : 'cursor-pointer'}`}
          onClick={() => handlePagination('next')}
          disabled={currentPage === totalPages}
        >
          chevron_right
        </span>

      </div>
    </div >
  );
}

export default ListCandidate;